import React, { useContext, useState, useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';
import Tab from '@material-ui/core/Tab';
import { PageContext } from '../../context';
import BookingsList from './BookingsList';
import { ContentWrapper, ScrollingContent } from '../../../BookingPage/styles';
import { LPText } from '../../../styles';
import { Tabs, SelectionTabs } from './styles';

const MyBookingsBody = () => {
  const {
    contextData: {
      bookingsData: { clientName, MyBookings } = {
        clientName: '',
        MyBookings: {},
      },
    },
  } = useContext(PageContext);

  const [tabValue, setTabValue] = useState(0);
  const [bookings, setBookings] = useState([]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  useEffect(() => {
    const filteredBookings = (tabValue === 1)
      ? MyBookings.filter((b) => b.days < 0)
      : MyBookings.filter((b) => b.days >= 0);
    setBookings(filteredBookings);

    return () => {
      setBookings([]);
    };
  }, [tabValue]);

  return (
    <>
      <LPText small padded>
        {`Hi ${clientName}, check out your upcoming appointments.`}
      </LPText>
      <SelectionTabs>
        <Tabs variant="fullWidth" value={tabValue} onChange={handleTabChange}>
          <Tab label="UPCOMING" />
          <Tab label="PAST" />
        </Tabs>
      </SelectionTabs>
      <ContentWrapper nopadding>
        <ScrollingContent>
          <SwipeableViews index={tabValue} onChangeIndex={handleChangeIndex}>
            <BookingsList index={0} bookingsList={bookings} />
            <BookingsList index={1} bookingsList={bookings} />
          </SwipeableViews>
        </ScrollingContent>
      </ContentWrapper>
    </>
  );
};

export default MyBookingsBody;
